<template>
  <div class="creat"
      v-if="show">
    <van-cell-group>
      <van-field clearable
                label="规则说明"
                type="text"
                :value="dayMsg"
                disabled></van-field>
      <van-field v-if="status === 'edit'"
                clearable
                required
                label="请假类型"
                type="text"
                placeholder="请选择请假类型"
                :value="leavetypeMsg"
                disabled></van-field>
      <van-field v-else
                  clearable
                  required
                  label="请假类型"
                  type="text"
                  placeholder="请选择请假类型"
                  :value="leavetypeMsg"
                  disabled
                  @click="showLeaveType"></van-field>
      <div v-if="status === 'edit'">
        <van-field v-if="rowRoleType.RoleType === 3"
                  clearable
                  required
                  label="请假学生"
                  type="text"
                  placeholder="选择学生"
                  :value="replaceStudent.name"
                  disabled></van-field>
        <van-field v-else
                  clearable
                  required
                  label="请假学生"
                  type="text"
                  placeholder="选择学生"
                  :value="studentName"
                  disabled></van-field>
      </div>
      <div v-else>
        <van-field v-if="rowRoleType.RoleType === 3"
                  clearable
                  required
                  label="请假学生"
                  type="text"
                  placeholder="选择学生"
                  :value="replaceStudent.name"
                  disabled></van-field>
        <!-- <van-field v-else
                  clearable
                  required
                  label="请假学生"
                  type="text"
                  placeholder="选择学生"
                  :value="studentName"
                  @click="showStudentList"
                  disabled></van-field> -->
      </div>
      <div v-if="status === 'edit'">
        <van-field v-if="typeList.radio === 1"
                  clearable
                  required
                  type="text"
                  label="请假时间"
                  placeholder="请假时间"
                  :value="leaveTime"
                  disabled></van-field>
        <van-cell v-else
                  title="周期性请假"
                  is-link
                  value="是" />
      </div>
      <div v-else>
        <van-field v-if="typeList.radio === 1"
                  clearable
                  required
                  type="text"
                  label="请假时间"
                  placeholder="请假时间"
                  :value="leaveTime"
                  disabled
                  @click="showSelectTime"></van-field>
        <van-cell v-else
                  title="周期性请假"
                  is-link
                  value="是" />
                  
                  <!-- @click="showSelectTime" -->
      </div>
      <div v-if="typeList.radio === 2"
          class="cycle-box">
        <!-- CycleDetail -->
        <div class="cycle-cont"
            v-if="status === 'edit'">
          <div class="cycle-cont-list"
              v-for="(item,index) in typeList.CycleList"
              v-bind:key="index">
            <div class="list-name">{{item}}</div>
          </div>
        </div>

        <div class="cycle-cont"
            v-else>
          <div class="cycle-cont-tit">{{typeList.SETime[0]}} - {{typeList.SETime[1]}}</div>
          <div class="cycle-cont-list"
              v-for="(item,index) in typeList.CycleList"
              v-bind:key="index">
            <div class="list-name">{{item.Name}}</div>
            <div class="list-time-box">
              <span v-for="(itemTime,indexTime) in item.TimeList"
                v-bind:key="indexTime">{{itemTime.StartTime}} - {{itemTime.EndTime}}</span>
            </div>
          </div>
        </div>
      </div>
      <van-field style="height: 100px"
                clearable
                required
                type="textarea"
                label="请假原因"
                :maxlength="100"
                v-bind:disabled="status === 'edit'"
                placeholder="请输入请假原因"
                v-model="description"></van-field>
      <van-cell-group>
        <van-switch-cell v-bind:disabled="status === 'edit'"
                        v-model="isLeaveSchool"
                        title="是否离校" />
      </van-cell-group>
      <van-cell center
                title="图片"></van-cell>
      <div v-if="status === 'edit'">
        <div v-if="images.length > 0">
          <div v-for="(item, index) in images"
              v-bind:key="index"
              style="display: inline-block;">
            <img v-bind:src="item"
                style="width: 80px; height: 80px; margin: 0 8px 8px 18px;" />
          </div>
        </div>
        <van-cell v-else
                  center
                  title="无"></van-cell>
      </div>
      <div v-else>
        <template slot="default"
                  class="van-cell"
                  style="padding: 4vw 4.8vw">
          <van-uploader v-model="fileList"
                        multiple
                        :before-read="beforeRead"
                        :max-count="6"></van-uploader>
          <span v-cloak
                style="color:#B0B0B0;">请上传10M以内的图片</span>
        </template>
      </div>

      <div v-if="status === 'edit'">
        <van-cell center
                  title="审批流程"></van-cell>
        <ApprovalFlow :dataList="barchData"
                      style=" padding: 0 20px;"></ApprovalFlow>
      </div>
      <div v-else>
        <van-cell center
                  title="审批流程"></van-cell>
        <CreatFlow :data="barchData"
                   v-if="showFlow"></CreatFlow>
        <div v-else
             style="color: red; padding-top: 12px; padding-bottom: 12px; margin-bottom: 80px; text-align: center;">审批人未设置审批权限，请联系管理员</div>
      </div>
    </van-cell-group>
    <!-- 请假类型 -->
    <van-popup v-model="isShowTypeSheet"
               position="bottom"
               :style="{ height: '45%' }">
      <ul class="leaveType">
        <li v-for="(item,index) in leaveTypeData"
            :key="index"
            @click="checkType(item)">{{item.name}}</li>
      </ul>
    </van-popup>
    <van-popup v-model="isShowStartSection"
               position="bottom"
               :style="{ height: '45%' }">
      <ul class="list-wrap">
        <li class="item"
            v-for="item in sectionList"
            @click="choseSectionItem('startSection', item)"
            :key="item.CTTCNName">{{item.CTTCNName}}</li>
      </ul>
    </van-popup>
    <van-popup v-model="isShowEndSection"
               position="bottom"
               :style="{ height: '45%' }">
      <ul class="list-wrap">
        <li class="item"
            v-for=" item in sectionList"
            @click="choseSectionItem('endSection', item)"
            :key="item.CTTCNName">{{item.CTTCNName}}</li>
      </ul>
    </van-popup>
    <!-- 选择学生层级 -->
    <van-popup v-model="selectStudentShow"
               position="right"
               :style="{ height: '100%',width:'100%', background: '#f5f5f5',overflow: 'hidden'}">
      <div class="more">
        <div class="more-top">
          <div class="more-top-left">
            <div class="school"
                 v-for="(item,index) in schoolList"
                 v-bind:key="index"
                 v-bind:class="index===schoolIndex ? 'active':''"
                 @click="selectSchool(item,index)">{{item.Name}}</div>
          </div>

          <div class="more-top-cont">
            <div class="grade"
                 v-for="(item,index) in sessionList"
                 v-bind:key="index"
                 v-bind:class="index===sessionIndex ? 'active':''"
                 @click="selectSession(item,index)">{{item.Name}}</div>
          </div>
          <div class="more-top-right">
            <div class="class-data"
                 v-for="(item,index) in gradelList"
                 v-bind:key="index"
                 v-bind:class="index===gradelIndex ? 'active':''"
                 @click="selectGradel(item,index)">{{item.Name}}</div>
          </div>
          <div class="more-top-list">
            <div class="class-data"
                 v-for="(item,index) in classList"
                 v-bind:key="index"
                 v-bind:class="index===classIndex ? 'active':''"
                 @click="selectClass(item,index)">{{item.Name}}</div>
          </div>
        </div>
      </div>
      <div class="more-btn">
        <van-button class="btn"
                    type="default"
                    @click="submit(0)">取消</van-button>
        <van-button class="btn"
                    type="info"
                    @click="submit(1)">确定</van-button>
      </div>
    </van-popup>

    <!-- 选择学生 -->
    <SelectStudent ref="selectStudent"
                   :isShowSelectStudent="isShowSelectStudent"
                   @SelectStudentClose="selectStudentClose"
                   @SelectStudent="selectStudent"></SelectStudent>

    <!-- 选择时间 -->
    <SelectTime ref="selectTimeDist"
                :isSelectTime="isSelectTime"
                @handleSelectTime="changeTime"
                @typeListFunction="getTypeList"></SelectTime>
    <div v-if="status === 'edit'">
      <div v-if="isRevoke">
        <SingleBottomBtn v-if="applicationState === 4">已撤销</SingleBottomBtn>
        <SingleBottomBtn v-else
                         @clickBtn="revoke">撤销</SingleBottomBtn>
      </div>
    </div>
    <div v-else>
      <SingleBottomBtn @clickBtn="postApproval">提交</SingleBottomBtn>
    </div>
  </div>
</template>
<script>
import SingleBottomBtn from "@/pages/attendance/components/SingleBottomBtn";
import SelectStudent from "@/pages/attendance/components/SelectStudent";
import SelectTime from "@/pages/attendance/components/SelectTime";
import CreatFlow from "../../../../components/workFlow/CreatFlow";
import ApprovalFlow from "../../../../components/workFlow/ApprovalFlow";

import { Notify } from "vant";
const cardImgUrl = require("@/assets/attendance/data_ask.png");

export default {
  name: "StudentLeaveSubCreate",
  components: {
    SingleBottomBtn,
    SelectStudent,
    SelectTime,
    CreatFlow,
    ApprovalFlow
  },
  data () {
    return {
      dayMsg: "",
      show: true,
      typeList: {
        radio: 1,
        SETime: []
      },
      filesUrls: [],
      leaveTime: "",
      showFlow: true,
      barchData: [],
      IsRevoke: false,
      LeaveModel: "",
      images: [],

      ApprovalFlowNodes: "",
      rowRoleType: "", //是否是学生本人请假
      selectStudentShow: false,
      schoolList: [],
      sessionList: [],
      gradelList: [],
      classList: [],
      studentListName: "",
      studentName: "",
      schoolIndex: -1,
      sessionIndex: -1,
      gradelIndex: -1,
      classIndex: -1,

      schoolID: 0,
      sessionID: 0,
      gradelID: 0,
      classID: 0,
      dataCurrent: "",
      beforeDay: 0,

      cardImgUrl: cardImgUrl,
      UserID: "",
      UserName: "",
      OrganizationID: "",
      leaveApplicationID: "",
      applicationState: "",
      isLeaveSchool: true,
      isShowTypeSheet: false,
      isShowStartDate: false,
      isShowEndDate: false,
      isShowEndSection: false,
      isShowStartSection: false,
      isShowSelectStudent: false,
      isSelectTime: false,
      replaceStudent: {
        name: "",
        id: ""
      },
      studentIDList: [],

      leavetypeMsg: "",
      leaveTypeData: [],
      leaveId: "",
      startKey: "",
      endKey: "",
      startSection: {
        AMorPM: "",
        AMorPMOrder: "",
        CTTCNName: "",
        CTTKey: "",
        Day: "",
        End: "",
        EndTime: "",
        Start: "",
        StartTime: ""
      },
      endSection: {
        AMorPM: "",
        AMorPMOrder: "",
        CTTCNName: "",
        CTTKey: "",
        Day: "",
        End: "",
        EndTime: "",
        Start: "",
        StartTime: ""
      },

      sectionList: [],
      fileList: [],
      picFileList: [],
      workFlowList: [],

      startDate: new Date().pattern("yyyy/MM/dd"),
      endDate: new Date().pattern("yyyy/MM/dd"),
      maxDate: new Date(2020, 12, 31),
      minDate: new Date(),
      approval: "",
      approvalId: "",
      dayNum: "",
      description: "",
      // 审批详情时需要
      approvalData: {
        ApprovalFlowNodeID: undefined //当前审批节点的id
      },
      isRevoke: true,

      originPage: "",
      status: "" // 创建or编辑
    };
  },
  created () {
    // 获取用户信息
    this.getUserInfo();
  },
  mounted () { },
  computed: {
    canEdit () {
      console.log(this.applicationState);
      return this.applicationState === 1 && this.status === "edit";
    }
  },
  methods: {
    //获取用户信息
    async getUserInfo () {
      let res = await this.xyapi.get(
        this.xyMApi + "/api/Users/GetUserInfo"
      );
      if (res.success) {
        this.rowRoleType = res.data;
        this.UserID = res.data.UserID;
        this.UserName = res.data.UserName;
        this.OrganizationID = res.data.OrganizationID;
        // if (this.rowRoleType.RoleType === "3") {
        //   this.replaceStudent = {
        //     name: res.data.FullName,
        //     id: res.data.UserID
        //   };
        // }
        if (this.rowRoleType.RoleType === "4") {
          this.rowRoleType.RoleType = 3;
          this.replaceStudent = {
            name: this.$store.state.parentInfo.childData.FullNameStudent,
            id: this.$store.state.parentInfo.childData.ChildrenID
          };
        }
        console.log(this.rowRoleType);
        // 获取上页传来的数据
        this.getParams();
      }
    },
    // 获取上页传来的数据---判断是新建还是查看
    getParams () {
      let params = this.$route.query;
      this.status = params.status;
      // 获取可请过去几天假
      this.GetLeaveSetting();
      // rowRoleType.RoleType === 3  是学生自己
      if (this.rowRoleType.RoleType === 3) {
        this.originPage = "Other";
      } else {
        this.originPage = params.originPage;
      }
      console.log(this.originPage);
      console.log("---------------------------------");
      if (this.status === "edit") {
        this.isRevoke = JSON.parse(params.params).IsRevoke;
        let { LeaveApplicationID } = JSON.parse(params.params);

        this.leaveApplicationID = LeaveApplicationID;

        // 获取用户状态
        this.GetStudentLeaveByID();
      }
    },

    // 获取用户状态
    async GetStudentLeaveByID () {
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/StudentLeave/GetStudentLeaveByID",
        {
          LeaveApplicationID: this.leaveApplicationID
        }
      );
      if (res.success) {
        console.log(res.data);

        for (var i = 0; i < res.data.ApprovalFlowNodes.length; i++) {
          res.data.ApprovalFlowNodes[i].CCUsers =
            res.data.ApprovalFlowNodes[i].CcMemberList;
        }
        this.workFlowList = res.data.ApprovalFlowNodes; //审批流
        this.LeaveModel = res.data.LeaveModel;

        this.studentListName = this.LeaveModel.Details;
        this.leavetypeMsg = this.LeaveModel.LeaveTypeName;
        this.OrganizationID = this.LeaveModel.OrganizationID;
        if (this.LeaveModel.Details.length > 0) {
          for (let i = 0; i < this.LeaveModel.Details.length; i++) {
            this.studentName =
              this.studentName + this.LeaveModel.Details[i].StudentName + ",";
          }
          this.studentName = this.studentName.substring(
            0,
            this.studentName.length - 1
          );
        } else {
          this.replaceStudent = {
            name: this.studentName,
            id: 0,//StudentID
          };
        }
        if (this.LeaveModel.IsCycleLeave) {
          this.typeList.radio = 2;
          this.typeList.SETime[0] = this.LeaveModel.StartTime;
          this.typeList.SETime[1] = this.LeaveModel.EndTime;
        } else {
          this.typeList.radio = 1;
          this.leaveTime =
            this.LeaveModel.StartTime + "-" + this.LeaveModel.EndTime;
        }
        this.typeList.CycleList = this.LeaveModel.CycleDetail;
        this.description = this.LeaveModel.ApplicationDescription;
        this.isLeaveSchool = this.LeaveModel.IsLeaveSchool;
        this.images = this.LeaveModel.Images;
        this.applicationState = this.LeaveModel.ApplicationState;

        if (this.status === "edit") {
          this.barchData = res.data.ApprovalFlowNodes;
          this.formatBarchData(this.barchData);
        } else {
          this.getBarch();
        }
      }
    },

    //当前审批节点获取
    formatBarchData (data) {
      let _this = this;
      var lastPass_node = 0; // 临时记载：当前遍历中，最后通过审批的节点索引下标；其中，第0个为发起人，即尚未有审批
      data.currentAuditNodeIndex = -1; // 当前待审批节点的下标
      data.map((element, index) => {
        console.log(element);
        // 缩略预览模式开关
        element.isOverviewMode = true;
        // 缩略预览列表(不大于5个)
        element.overviewList = []; // 缩略预览列表(不大于5个)
        element.isFinished = false; // 该节点是否审批结束，原因见上
        element.currentAuditNode = false; // 该节点是否为当前待审核节点
        // 若该审批项目结束，缩略列表显示最后审批结果的时间与状态
        element.lastComplete_time = undefined;
        element.lastComplete_status = undefined;
        if (element.IsComplete) {
          // 该节点已经通过了审批，相当于 element.Status === '已通过'
          lastPass_node = index;
          element.isFinished = true;
        } else if (element.Status === "已拒绝") {
          element.isFinished = true;
        } else if (element.Status === "待审批") {
          // 判断是否为当前节点
          if (lastPass_node + 1 === index) {
            // 该节点为当前待审核节点
            element.currentAuditNode = true;
            data.currentAuditNodeIndex = index;
          }
        }

        var lastTime_member = undefined; // 暂存：最近的一次时间点
        element.ApprovalMemberList.forEach(function (memberItem, memberIndex) {
          // 缩略图列表仅显示前4个，其余显示省略号；若共5人，则不显示省略号，直接全部显示
          if (memberIndex < 4 || element.ApprovalMemberList.length === 5) {
            element.overviewList.push(memberItem);
          }
          // 若该节点完成，显示时间、结果
          if (element.isFinished && memberItem.Status !== "待审批") {
            if (element.ApprovalFlowNodeName === "或签") {
              // 记录唯一一次审批时间
              element.lastComplete_time = memberItem.ApprovalDate;
              element.lastComplete_status = memberItem.Status;
            } else if (element.ApprovalFlowNodeName === "会签") {
              // 记录最后一次会签时间
              if (lastTime_member === undefined) {
                // 记载首次审批的时间
                lastTime_member = memberItem.ApprovalDate;
              } else {
                var lastTime = new Date(lastTime_member);
                var thisTime = new Date(memberItem.ApprovalDate);
                if (thisTime > lastTime) {
                  element.lastComplete_time = memberItem.ApprovalDate;
                  element.lastComplete_status = memberItem.Status;
                }
              }
            }
          }
          if (!element.isFinished) {
            // 获取当前需审批的节点：第一个非完成节点
            if (
              _this.approvalData.ApprovalFlowNodeID === undefined &&
              element.ApprovalFlowNodeName !== "发起人"
            ) {
              console.log(element);
              _this.approvalData.ApprovalFlowNodeID =
                element.ApprovalFlowNodeID;
            }
          }
        });
        // 抄送列表，大致逻辑同上
        element.isOverviewMode_CC = true;
        element.overviewList_CC = [];
        element.ApprovalCCMemberList.forEach(function (CCItem, CCIndex) {
          // 缩略图列表仅显示前4个，其余显示省略号；若共5人，则不显示省略号，直接全部显示
          if (CCIndex < 4 || element.ApprovalCCMemberList.length === 5) {
            element.overviewList_CC.push(CCItem);
          }
        });
      });
    },
    //获取可请过去几天假
    async GetLeaveSetting () {
      this.xy.loading();
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/StudentLeaveType/GetLeaveSetting"
      );
        console.log(this.originPage)
      if (res.success) {
        // 代请假
        if (this.originPage === "applys") {
          this.beforeDay = res.data.PastDate;
        } else {
          this.beforeDay = res.data.PastDate;
        }
        this.dayMsg = "可请过去" + this.beforeDay + "天假";
        // 获取请假类型
        this.getLeaveType();
      }
    },

    // 获取请假类型
    async getLeaveType () {
      let that = this;
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/StudentLeaveType/GetTypeAll"
      );
      if (res.success) {
        that.leaveTypeData = [];
        res.data &&
          res.data.forEach(function (value) {
            that.leaveTypeData.push({
              name: value.LeaveTypeName,
              id: value.LeaveTypeID
            });
          });
        this.xy.unloading();
      }
    },
    // 点击展开请假类型
    showLeaveType () {
      if (this.applicationState !== 1 && this.status === "edit") {
        return;
      }
      this.isShowTypeSheet = true;
    },
    // 点击选择请假类型
    checkType (item) {
      this.leavetypeMsg = item.name;
      this.leaveId = item.id;
      this.isShowTypeSheet = false;
    },
    // 点击展开选择学生
    showStudentList () {
      this.StudentOrganization();
    },
    // 根据校区查询
    async StudentOrganization () {
      this.schoolList = [];
      this.sessionList = [];
      this.gradelList = [];
      this.classList = [];

      this.schoolIndex = -1;
      this.sessionIndex = -1;
      this.gradelIndex = -1;
      this.classIndex = -1;
      let res = await this.xyapi.get(
        this.xyMApi + "/xy/comm/StudentOrganization",
        {
          id: 0,
          type: ""
        }
      );
      if (res.success) {
        this.schoolList = res.data;
        this.selectStudentShow = true;
      }
    },
    // 选择校区
    selectSchool (val, i) {
      this.schoolIndex = i;
      this.sessionList = val.MemberList;
      this.sessionIndex = -1;
      this.gradelIndex = -1;
      this.classIndex = -1;
      this.dataCurrent = val;
      this.schoolID = val;
      this.gradelList = [];
      this.classList = [];
    },
    // 选择学届
    selectSession (val, i) {
      this.sessionIndex = i;
      this.gradelList = val.MemberList;
      this.gradelIndex = -1;
      this.classIndex = -1;
      this.dataCurrent = val;
      this.sessionID = val;
      this.classList = [];
    },
    // 选择年级
    selectGradel (val, i) {
      this.gradelIndex = i;
      this.classList = val.MemberList;
      this.classIndex = -1;
      this.dataCurrent = val;
      this.gradelID = val;
    },
    // 选择班级数据
    selectClass (val, i) {
      this.classIndex = i;
      this.dataCurrent = val;
      this.classID = val;
      this.OrganizationID = this.dataCurrent.ID;
    },
    // 点击选择层级确定
    submit (val) {
      if (val === 1) {
        // 关闭下拉框
        this.selectStudentShow = false;
        // 打开选择学生界面
        this.isShowSelectStudent = true;
        this.$refs.selectStudent.onLoad();
      } else {
        // 关闭下拉框
        this.selectStudentShow = false;
      }
    },
    // 点击关闭选择学生
    selectStudentClose () {
      this.isShowSelectStudent = false;
    },
    // 点击选择学生
    selectStudent (item) {
      this.isShowSelectStudent = false;
      this.studentListName = item;
      let studentName = "";
      let studentID = [];

      // 代请假
      if (this.originPage === "apply") {
        for (var i = 0; i < this.studentListName.length; i++) {
          studentName = studentName + this.studentListName[i].FullName + ",";
          studentID.push(this.studentListName[i].UserID);
        }
      }
      this.studentIDList = studentID;
      this.studentName = studentName.substring(0, studentName.length - 1);

      if (this.typeList.SETime.length === 2) {
        // 有学生和请假时间后才---调用获取审批流程
        this.getBarch();
      }
    },
    // 请假时间
    showSelectTime () {
      this.isSelectTime = true;
      this.$refs.selectTimeDist.selectTimeDist();
    },
    // 点击展开选择时间
    changeTime (val) {
      this.isSelectTime = val;
    },
    // 获取请假时间---子组件传来的数据并且重置数组
    getTypeList (item) {
      this.typeList = item;

      console.log("-----------------this.typeList.radio---------------------");
      console.log(this.typeList.radio);
      if (this.typeList.radio === 1) {
        this.leaveTime =
          this.typeList.SETime[0] + "-" + this.typeList.SETime[1];
      } else {
        for (var i = 0; i < this.typeList.CycleList.length; i++) {
          if (this.typeList.CycleList[i].Checked) {
            this.typeList.CycleList[i].TimeList.length > 1;
            for (
              var k = 0;
              k < this.typeList.CycleList[i].TimeList.length;
              k++
            ) {
              if (
                this.typeList.CycleList[i].TimeList[k].hasOwnProperty("isDel")
              ) {
                // console.log(this.typeList.CycleList[i].TimeList[k]);
              } else {
                // 删除文字项
                this.typeList.CycleList[i].TimeList.splice(k, 1);
              }
            }
          } else {
            this.typeList.CycleList[i] = [];
          }
        }
      }

      // 教师代请假
      if (this.originPage === "apply") {
        if (this.rowRoleType.RoleType === "3") {
          if (this.replaceStudent.id !== "") {
            this.getBarch();
          } else {
            return this.$toast.fail("请选择学生");
          }
        } else if (this.studentListName.length > 0) {
          this.getBarch();
        } else {
          return this.$toast.fail("请选择学生");
        }
      } else {
        // 有学生和请假时间后才---调用获取审批流程
        if (this.replaceStudent.id > 0) {
          this.getBarch();
        } else {
          return this.$toast.fail("请选择学生");
        }
      }
    },
    // 获取审批流程
    async getBarch () {
      //let studentListLength = 0;
      // 代请假
      if (this.originPage === "apply") {
        if (this.rowRoleType.RoleType === "3") {
          if (this.rowRoleType.RoleType === "") {
            if (this.replaceStudent.id !== "") {
              //studentListLength = 1;
            } else {
              return this.$toast.fail("请选择学生");
            }
          }
        } else {
          if (this.studentListName.length <= 0) {
            return this.$toast.fail("请选择学生");
          } else {
            //studentListLength = this.studentListName.length;
          }
        }
      } else {
        // 教师代请假
        if (this.replaceStudent.id <= 0) {
          return this.$toast.fail("请选择学生");
        }
      }

      let m1 = this.xy.moment(this.typeList.SETime[0]);
      let m2 = this.xy.moment(this.typeList.SETime[1]);
      let dayNum = m2.diff(m1, "day") + 1;

      let res = await this.xyapi.post(
        this.$store.state.apiPath +
        "/api/StudentLeaveFlowSetting/ApprovalProcessByCondition",
        {
          // 教师代请假传""
          StudentID: this.originPage === "apply" ? "" : this.replaceStudent.id,
          // 教师代请假传this.OrganizationID   否则0
          OrganizationID:
            this.originPage === "apply" ? this.OrganizationID : "",
          WorkFlowType: 3, //学生请假
          ConditionValues: [
            {
              Type: 0,
              Code: 1, //请假时长类型
              Value: dayNum //天数
            },
            {
              Type: 0,
              Code: 2, //请假人数
              Value: 1 //人数
            }
          ]
        }
      );
      if (res.success) {
        if (res.data) {
          var dataArr = [];
          dataArr = res.data;
          // dataArr = [
          //   {
          //     WorkFlowID: 43002,
          //     WorkFlowNodeID: 62086,
          //     NodeType: 2,
          //     ApprovalMemberRoleID: 0,
          //     ApprovalMemberType: 0,
          //     ApprovalMode: 0,
          //     Level: 0,
          //     ParentID: 0,
          //     IsApprovalMySelf: true,
          //     IsApprovalComplete: true,
          //     WorkFlowNodeName: "",
          //     ApprovalMemberList: [
          //       {
          //         UserID: 7096,
          //         FullName: "教师001"
          //       },
          //       {
          //         UserID: 8519,
          //         FullName: "教师002"
          //       }
          //     ],
          //     CcMemberList: [
          //       { DisplayName: "抄送", FullName: "刘庚教师", UserID: 2001 },
          //       { DisplayName: "抄送", FullName: "刘11", UserID: 2002 }
          //     ],
          //     WorkFlowNodeModels: null,
          //     WorkFlowConditions: null
          //   }
          // ];

          for (var i = 0; i < dataArr.length; i++) {
            dataArr[i].CCUsers = dataArr[i].CcMemberList;
            dataArr[i].ApprovalUsers = dataArr[i].ApprovalMemberList;
          }
          this.barchData = dataArr;

          this.barchData.map(item => {
            if (item.NodeType === 2 && item.ApprovalMemberType !== 0) {
              this.showFlow = item.ApprovalMemberList.length > 0 ? true : false;
            }
          });

          console.log(this.showFlow);
          console.log(this.barchData);
        }
      }
    },

    // 上传图片前校验
    beforeRead (file) {
      var imgMasSize = 1024 * 1024 * 10;
      if (file.length + this.fileList.length > 6) {
        this.$toast.fail("最多只能上传6张图片");
        return;
      } else {
        if (typeof file === "object" && !isNaN(file.length)) {
          // 多长图片 数组
          for (var i = 0; i < file.length; i++) {
            if (
              ["jpeg", "png", "bmp", "jpg"].indexOf(
                file[i].type.split("/")[1]
              ) < 0
            ) {
              this.$toast.fail("文件类型仅支持 jpeg，png，jpg，bmp");
              return;
            }
            if (file[i].size > imgMasSize) {
              this.$toast.fail("单张图片不能超过10M");
              return;
            }
          }

          var formData = new FormData();
          for (var j = 0; j < file.length; j++) {
            // name
            formData.append("name", file[j].name);
            // type
            formData.append("type", file[j].type);
            // size
            formData.append("size", file[j].size);
            // lastModifiedDate
            formData.append("lastModifiedDate", file[j].lastModifiedDate);
            // append 文件
            formData.append("File", file[j], "photo.jpg");
          }
          this.afterRead(formData);
        } else {
          // 单张图片 对象
          if (
            ["jpeg", "png", "bmp", "jpg"].indexOf(file.type.split("/")[1]) < 0
          ) {
            this.$toast.fail("文件类型仅支持 jpeg，png，jpg，bmp");
            return;
          }
          if (file.size > imgMasSize) {
            this.$toast.fail("单张图片不能超过10M");
            return;
          }
          let formData = new FormData();
          // name
          formData.append("name", file.name);
          // type
          formData.append("type", file.type);
          // size
          formData.append("size", file.size);
          // lastModifiedDate
          formData.append("lastModifiedDate", file.lastModifiedDate);
          // append 文件
          formData.append("File", file, "photo.jpg");
          this.afterRead(formData);
        }
      }
    },

    // 上传图片
    async afterRead (form) {
      this.picFileList = [];
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let res = await this.xyapi.post(
        this.$store.state.apiPath + "/api/StudentLeave/IconUpload",
        form,
        config
      );
      if (res.success) {
        this.picFileList = res.data.result;
        for (var i = 0; i < this.picFileList.length; i++) {
          this.fileList.push({
            url: this.$store.state.apiPath + this.picFileList[i]
          });
        }
      }
    },

    showStartDate () {
      if (this.applicationState !== 1 && this.status === "edit") {
        return;
      }
      this.isShowStartDate = true;
    },
    showEndDate () {
      if (this.applicationState !== 1 && this.status === "edit") {
        return;
      }
      this.isShowEndDate = true;
    },
    choseSectionItem (name, item) {
      this[name] = item;
      this.isShowEndSection = false;
      this.isShowStartSection = false;
    },

    // 创建提交
    postApproval () {
      let barchData = [];
      //isGo = false;
      //console.log(this.barchData);
      for (let i = 0; i < this.barchData.length; i++) {
        barchData.push({
          NodeType: this.barchData[i].NodeType, //节点类型
          ApprovalFlowNodeName: this.barchData[i].WorkFlowNodeName, //节点名称
          ApprovalMemberRoleID: this.barchData[i].ApprovalMemberRoleID, //审批成员类型 1：职务角色 2：自定义角色
          ApprovalMemberType: this.barchData[i].ApprovalMemberType, //审批成员类型 0：指定成员 1：职务角色 2：自定义角色 3：申请人选择
          ApprovalMode: this.barchData[i].ApprovalMode, //审批模式  会签 = 1  或签 = 0
          IsApprovalMySelf: this.barchData[i].IsApprovalMySelf, //审批人就是申请人（自己审批自己）
          IsApprovalComplete: this.barchData[i].IsApprovalComplete, //审批人已经审批通过
          ApprovalUsers: [], //item.ApprovalUsers,//审批人
          CCUsers: [] //item.CcMemberList//抄送人
        });
        //审批人
        if (this.barchData[i].NodeType === 2) {
          if (this.barchData[i].ApprovalMemberType === 0) {
            //会签/或签
            //isGo = true;
            console.log(this.barchData[i]);
            console.log(this.barchData[i].hasOwnProperty("ApprovalUsers"));

            if (this.barchData[i].hasOwnProperty("ApprovalUsers")) {
              this.barchData[i].ApprovalUsers.forEach(function (ap) {
                barchData[i].ApprovalUsers.push(ap.UserID);
              });
            }
          } else {
            //审批

            if (this.barchData[i].hasOwnProperty("sureData")) {
              if (this.barchData[i].sureData.length > 0) {
                //isGo = false;
                this.barchData[i].sureData.forEach(function (ap) {
                  //isGo = true;
                  barchData[i].ApprovalUsers.push(ap.UserID);
                });
              } else {
                //isGo = true;
              }
            } else {
              Notify({ type: "danger", message: "请选择审批人" });
              return false;
            }
          }
          console.log(barchData);
        } else {
          //抄送人
          console.log(this.barchData[i]);
          console.log(barchData.length);
          console.log([i].length);

          this.barchData[i].CcMemberList.forEach(function (cc) {
            barchData[i].CCUsers.push(cc.UserID);
          });
          console.log(barchData);

          // //抄送人
          // if (barchData.length - 1 === [i].length) {
          //   this.barchData[i].CcMemberList.forEach(function(cc) {
          //     // debugger;
          //     // console.log([i]);
          //     console.log(barchData);
          //     console.log(barchData[i]);
          //     // console.log(barchData[i].CCUsers);
          //     barchData[i].CCUsers.push(cc.UserID);
          //     // for (var v = 0; v < barchData.length; v++) {
          //     //   barchData[v].CCUsers.push(cc.UserID);
          //     // }
          //   });
          // }
        }
      }

      // 选择周期性请假
      if (this.typeList.radio === 2) {
        console.log(this.typeList);
        console.log(this.typeList.CycleList);
        let arrCycleList = this.typeList.CycleList;
        for (let i = 0; i < arrCycleList.length; i++) {
          delete arrCycleList[i].Name;
          delete arrCycleList[i].Checked;
        }

        for (let c = 0; c < this.typeList.CycleList.length; c++) {
          delete this.typeList.CycleList[c].isDel;
          if (this.typeList.CycleList[c].length === 0) {
            this.typeList.CycleList.splice(c, 1);
          }
        }
        console.log(this.typeList.CycleList);
      }
      
      console.log("-----------------this.typeList.radio---------------------");
      console.log(this.typeList.radio);
      let params = {
        LeaveTypeID: this.leaveId, //请假类型
        StudentIDs:
          this.originPage === "apply"
            ? this.studentIDList
            : [this.replaceStudent.id], //请假学生
        StartTime: this.typeList.SETime[0], //开始时间
        EndTime: this.typeList.SETime[1], //结束时间
        CycleList: this.typeList.radio === 2 ? this.typeList.CycleList : [], //周期性请假时间
        Images: this.picFileList, //请假图片
        IsCycleLeave: this.typeList.radio === 2 ? true : false, //是否周期性请假
        IsLeaveSchool: this.isLeaveSchool, //是否离校
        ApplicationDescription: this.description, //请假原因
        ApplicationType: 2, //1自己，2代请假
        ApprovalFlowNodes: barchData //审批流
      };
      
      // console.log(params);
      if (barchData.length > 0) {
        if (this.originPage === "apply") {
          // 代请假
          if (this.postVerify()) {
            if (this.status === "create") {
              this.postSubsituteCreate(params);
            } else {
              this.postSubsituteEdit(params);
            }
          }
        } else {
          // 请假
          if (this.postVerify()) {
            if (this.status === "create") {
              this.postCreate(params);
            } else {
              this.postEdit(params);
            }
          }
        }
      } else {
        Notify({ type: "danger", message: "请选择审批流" });
        return false;
      }
    },

    // 提交验证
    postVerify () {
      if (!this.showFlow) {
        Notify({ type: "danger", message: "请设置审批流" });
        return false;
      }
      if (!this.leaveId) {
        Notify({ type: "danger", message: "请选择请假类型" });
        return false;
      }
      if (!this.typeList.SETime[0]) {
        Notify({ type: "danger", message: "请选择开始时间" });
        return false;
      }
      if (!this.typeList.SETime[1]) {
        Notify({ type: "danger", message: "请选择结束时间" });
        return false;
      }
      if (!this.description) {
        Notify({ type: "danger", message: "请填写原因" });
        return false;
      }
      if (
        new Date(
          this.typeList.SETime[1] + " " + this.endSection.Start
        ).getTime() <
        new Date(
          this.typeList.SETime[0] + " " + this.startSection.Start
        ).getTime()
      ) {
        Notify({ type: "danger", message: "结束时间不能小于开始时间" });
        return false;
      }
      return true;
    },

    // 创建申请
    async postCreate (params) {
      let res = await this.xyapi.post(
        this.$store.state.apiPath + "/api/StudentLeave/ParentReplaceLeave",
        params
      );
      if (res.success) {
        this.$notify({ type: "success", message: "创建成功" });
        // this.$router.push("/home/StudentLeave/Application");
        this.$router.push("/homeSchool/StudentLeave");
      }
    },
    // 编辑申请
    async postEdit (params) {
      let res = await this.xyapi.post(
        this.$store.state.apiPath + "/api/StudentLeave/Edit",
        params
      );
      if (res.success) {
        Notify({ type: "success", message: "编辑成功" });
        // this.$router.push("/home/StudentLeave/Application");
        this.$router.push("/homeSchool/StudentLeave");
      } else {
        Notify({ type: "danger", message: res.msg });
      }
    },

    // 创建代请假申请
    async postSubsituteCreate (params) {
      let res = await this.xyapi.post(
        this.$store.state.apiPath + "/api/StudentLeave/ParentReplaceLeave",
        params
      );
      if (res.success) {
        Notify({ type: "success", message: "创建成功" });
        // this.$router.push("/home/StudentLeave/Application");
        this.$router.push("/homeSchool/StudentLeave");
      } else {
        Notify({ type: "danger", message: res.msg });
      }
    },
    // 编辑代请假申请
    async postSubsituteEdit (params) {
      let res = await this.xyapi.post(
        this.$store.state.apiPath + "/api/StudentLeave/Edit",
        params
      );
      if (res.success) {
        Notify({ type: "success", message: "编辑成功" });
        // this.$router.push("/home/StudentLeave/Application");
        this.$router.push("/homeSchool/StudentLeave");
      } else {
        Notify({ type: "danger", message: res.msg });
      }
    },

    // 撤销
    async revoke () {
      let res = await this.xyapi.post(
        `${this.$store.state.apiPath}/api/StudentLeave/ParentRevokeLeave?LeaveApplicationID=${this.leaveApplicationID}`
      );
      if (res.success) {
        this.$notify({ type: "success", message: "撤销成功" });
        // this.$router.push("/home/StudentLeave/Application");
        this.$router.push("/homeSchool/StudentLeave");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.creat {
  width: 100%;
  min-height: 736px;
  overflow: scroll;
}
.van-cell {
  padding: 30px 36px;
}
.leaveType {
  width: 100%;
  height: 100%;
  li {
    display: block;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
.bottom-btn {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  background: #fff;
  box-shadow: 0 2px 21px 0 rgba(186, 186, 186, 0.44);
  .van-button {
    display: block;
    width: 22%;
    height: 80px;
    line-height: 80px;
    color: #fff;
    font-weight: 700;
    font-size: 30px;
    font-weight: 400;
    margin: 10px auto 15px;
    text-align: center;
    border-radius: 45px;
    background: #4196ff !important;
  }
}
.cycle-box {
  background: rgba(249, 249, 249, 1);
  padding: 24px;
  .cycle-cont {
    background: rgba(245, 250, 255, 1);
    border: 1px solid rgba(228, 228, 235, 1);
    border-radius: 6px;
    font-size: 26px;
    .cycle-cont-tit {
      margin: 27px 19px 33px;
    }
    .cycle-cont-list {
      margin: 33px 19px 33px;
      .list-name {
        margin-bottom: 14px;
        color: #111;
      }
      .list-time-box {
        span {
          margin: 0 34px;
        }
      }
    }
    .cycle-cont-list:first-child {
      .list-name {
        color: #666;
      }
    }
  }
}
.van-uploader {
  padding: 4vw 4.8vw;
}
.more {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f9f9f9 !important;
  z-index: 111;
  overflow: auto;
  .more-top {
    display: flex;
    margin: 10px;
    padding-bottom: 40px;
    .more-top-left {
      flex: 0.25;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      .school {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
    .more-top-cont {
      flex: 0.25;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      border-left: 1px solid #eaeaea;
      border-right: 1px solid #eaeaea;
      .grade {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
    .more-top-right {
      flex: 0.25;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      border-right: 1px solid #eaeaea;
      .class-data {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
    .more-top-list {
      flex: 0.25;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      .class-data {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
  }
}
.more-btn {
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 999999 !important ;

  .btn {
    flex: 0.5;
    align-items: center;
    text-align: center;
    justify-content: flex-end;
  }
}
</style>

